var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreenNew", {
    attrs: { size: "lg2", withBgClickEvent: true, modalId: "modal-lv2" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ invalid, handleSubmit }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.onSubmit)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex items-center w-full smartFormToggle",
                            },
                            [
                              _c("FormToggleNew", {
                                attrs: {
                                  label: "Smart Match Configuration",
                                  labelHorizontal: true,
                                  labelLeft: true,
                                },
                                on: { toggle: _vm.handleMasterToggle },
                                model: {
                                  value: _vm.formData.smart_match_enabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "smart_match_enabled",
                                      $$v
                                    )
                                  },
                                  expression: "formData.smart_match_enabled",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm leading-6 font-400 text-gray-new mb-6",
                            },
                            [
                              _vm._v(
                                " Customize how you match resources to clients based on your specific requirements. "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mb-8 sectionContainer",
                              class: {
                                "opacity-50 pointer-events-none":
                                  !_vm.formData.smart_match_enabled,
                              },
                            },
                            [
                              _c("div", { staticClass: "pb-4 mb-2" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "text-lg font-medium text-gray-900",
                                  },
                                  [_vm._v("Must-Haves")]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "text-sm text-gray-600 mt-1" },
                                  [
                                    _vm._v(
                                      " These criteria are mandatory for matching resources to clients. "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "mb-6 toggleContainer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c("FormToggleNew", {
                                        attrs: {
                                          label: "Availability",
                                          labelHorizontal: true,
                                          disabled:
                                            !_vm.formData.smart_match_enabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData.availability_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "availability_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.availability_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "text-sm text-gray-600" },
                                    [
                                      _vm._v(
                                        " The resource must be available to match. "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "mb-6 toggleContainer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c("FormToggleNew", {
                                        attrs: {
                                          label: "Exclude Do Not Use",
                                          labelHorizontal: true,
                                          disabled:
                                            !_vm.formData.smart_match_enabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .exclude_do_not_use_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "exclude_do_not_use_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.exclude_do_not_use_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "text-sm text-gray-600" },
                                    [
                                      _vm._v(
                                        " Exclude candidates marked as Do Not Use. "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "mb-6 toggleContainer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c("FormToggleNew", {
                                        attrs: {
                                          label: "Required Skills",
                                          labelHorizontal: true,
                                          disabled:
                                            !_vm.formData.smart_match_enabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .required_skills_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "required_skills_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.required_skills_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "text-sm text-gray-600" },
                                    [
                                      _vm._v(
                                        " Resource must have skills that match with project requirements when toggled on. "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "mb-6 toggleContainer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c("FormToggleNew", {
                                        attrs: {
                                          label: "Location Radius",
                                          labelHorizontal: true,
                                          disabled:
                                            !_vm.formData.smart_match_enabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .location_radius_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "location_radius_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.location_radius_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.formData.location_radius_enabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center space-x-4",
                                        },
                                        [
                                          _c("FormInputGroupNew", {
                                            staticClass: "fullWidth",
                                            attrs: {
                                              type: "number",
                                              placeholder: "25",
                                              disabled:
                                                !_vm.formData
                                                  .smart_match_enabled,
                                            },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .location_radius_value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "location_radius_value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.location_radius_value",
                                            },
                                          }),
                                          _c("FormSelectNew", {
                                            staticClass: "fullWidth",
                                            attrs: {
                                              options: _vm.radiusUnitOptions,
                                              disabled:
                                                !_vm.formData
                                                  .smart_match_enabled,
                                            },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .location_radius_unit,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "location_radius_unit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.location_radius_unit",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text-sm text-gray-600 mt-2",
                                    },
                                    [
                                      _vm._v(
                                        " Filter resource within specified distance. "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "mb-6 toggleContainer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c("FormToggleNew", {
                                        attrs: {
                                          label: "Preferred Language",
                                          labelHorizontal: true,
                                          disabled:
                                            !_vm.formData.smart_match_enabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .preferred_language_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "preferred_language_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.preferred_language_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.formData.preferred_language_enabled
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "block text-sm font-medium text-gray-700 mb-2",
                                            },
                                            [_vm._v(" Proficiency Level ")]
                                          ),
                                          _c("FormSelectNew", {
                                            staticClass: "fullWidth",
                                            attrs: {
                                              options: _vm.proficiencyOptions,
                                              disabled:
                                                !_vm.formData
                                                  .smart_match_enabled,
                                            },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .preferred_language_proficiency,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "preferred_language_proficiency",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.preferred_language_proficiency",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text-sm text-gray-600 mt-2",
                                    },
                                    [
                                      _vm._v(
                                        " Resource must have required proficiency level in the client’s preferred language to match. "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mb-8 sectionContainer",
                              class: {
                                "opacity-50 pointer-events-none":
                                  !_vm.formData.smart_match_enabled,
                              },
                            },
                            [
                              _c("div", { staticClass: "pb-4 mb-2" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "text-lg font-medium text-gray-900",
                                  },
                                  [_vm._v("Nice-to-Haves")]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "text-sm text-gray-600 mt-1" },
                                  [
                                    _vm._v(
                                      " Drag and drop these criteria to set their order of importance. "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "space-y-4" },
                                _vm._l(
                                  _vm.niceToHaveCriteria,
                                  function (criterion, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: criterion.type,
                                        staticClass:
                                          "border border-gray-200 rounded-lg p-4 bg-white",
                                        class: {
                                          "opacity-50":
                                            _vm.draggedIndex === index,
                                          "border-blue-300 bg-blue-50":
                                            _vm.dragOverIndex === index &&
                                            _vm.draggedIndex !== index,
                                        },
                                        attrs: {
                                          draggable:
                                            _vm.formData.smart_match_enabled &&
                                            !_vm.isDraggingSlider,
                                        },
                                        on: {
                                          dragstart: function ($event) {
                                            return _vm.handleDragStart(
                                              index,
                                              $event
                                            )
                                          },
                                          dragover: function ($event) {
                                            return _vm.handleDragOver(
                                              index,
                                              $event
                                            )
                                          },
                                          dragleave: _vm.handleDragLeave,
                                          drop: function ($event) {
                                            return _vm.handleDrop(index, $event)
                                          },
                                          dragend: _vm.handleDragEnd,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center justify-between",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center space-x-3 w-full",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "drag-handle cursor-move text-gray-400 hover:text-gray-600",
                                                    class: {
                                                      "cursor-not-allowed":
                                                        !_vm.formData
                                                          .smart_match_enabled,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass: "w-5 h-5",
                                                        attrs: {
                                                          fill: "currentColor",
                                                          viewBox: "0 0 20 20",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "flex-1" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex items-center mb-2 niceToHaveToggle",
                                                      },
                                                      [
                                                        _c("FormToggleNew", {
                                                          attrs: {
                                                            label:
                                                              criterion.label,
                                                            labelHorizontal: true,
                                                            disabled:
                                                              !_vm.formData
                                                                .smart_match_enabled,
                                                          },
                                                          model: {
                                                            value:
                                                              criterion.enabled,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                criterion,
                                                                "enabled",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "criterion.enabled",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-600",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              criterion.description
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    criterion.enabled
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-3",
                                                          },
                                                          [
                                                            criterion.type ===
                                                            "previous_engagements"
                                                              ? _c("div", [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "block text-sm font-medium text-gray-700 mb-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Minimum Previous Visits "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("div", [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "flex justify-between text-xs text-gray-500 mb-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "0"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "1-3"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "4-6"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "7-9"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "10+"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.previousEngagementsSliderValue,
                                                                              expression:
                                                                                "previousEngagementsSliderValue",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "w-full h-4 bg-gray-200 rounded-lg appearance-none cursor-pointer slider",
                                                                        attrs: {
                                                                          type: "range",
                                                                          min: "0",
                                                                          max: "4",
                                                                          step: "1",
                                                                          disabled:
                                                                            !_vm
                                                                              .formData
                                                                              .smart_match_enabled,
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm.previousEngagementsSliderValue,
                                                                          },
                                                                        on: {
                                                                          mousedown:
                                                                            _vm.handleSliderMouseDown,
                                                                          mouseup:
                                                                            _vm.handleSliderMouseUp,
                                                                          touchstart:
                                                                            _vm.handleSliderTouchStart,
                                                                          touchend:
                                                                            _vm.handleSliderTouchEnd,
                                                                          dragstart:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.preventDefault()
                                                                              $event.stopPropagation()
                                                                            },
                                                                          drag: function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            $event.stopPropagation()
                                                                          },
                                                                          __r: function (
                                                                            $event
                                                                          ) {
                                                                            _vm.previousEngagementsSliderValue =
                                                                              $event.target.value
                                                                          },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "text-xs text-gray-500 mt-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Selected: " +
                                                                            _vm._s(
                                                                              _vm.getPreviousEngagementsLabel(
                                                                                _vm.previousEngagementsSliderValue
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                                ])
                                                              : _vm._e(),
                                                            criterion.type ===
                                                            "transportation"
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "block text-sm font-medium text-gray-700 mb-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Transportation Methods "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "TransportationMultiselect",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            !_vm
                                                                              .formData
                                                                              .smart_match_enabled,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.selectedTransportation,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.selectedTransportation =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "selectedTransportation",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            criterion.type ===
                                                            "rating"
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "block text-sm font-medium text-gray-700 mb-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Minimum Rating (" +
                                                                            _vm._s(
                                                                              _vm
                                                                                .formData
                                                                                .rating_min_stars
                                                                            ) +
                                                                            " stars) "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "StarRating",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            !_vm
                                                                              .formData
                                                                              .smart_match_enabled,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .formData
                                                                              .rating_min_stars,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.formData,
                                                                                "rating_min_stars",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "formData.rating_min_stars",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            criterion.type ===
                                                            "hours_available"
                                                              ? _c("div", [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "block text-sm font-medium text-gray-700 mb-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Minimum Available Hours per Week (" +
                                                                          _vm._s(
                                                                            _vm
                                                                              .formData
                                                                              .hours_available_min
                                                                          ) +
                                                                          ") "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .formData
                                                                              .hours_available_min,
                                                                          expression:
                                                                            "formData.hours_available_min",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "w-48 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider",
                                                                    attrs: {
                                                                      type: "range",
                                                                      min: "1",
                                                                      max: "60",
                                                                      step: "1",
                                                                      disabled:
                                                                        !_vm
                                                                          .formData
                                                                          .smart_match_enabled,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .hours_available_min,
                                                                    },
                                                                    on: {
                                                                      mousedown:
                                                                        _vm.handleSliderMouseDown,
                                                                      mouseup:
                                                                        _vm.handleSliderMouseUp,
                                                                      touchstart:
                                                                        _vm.handleSliderTouchStart,
                                                                      touchend:
                                                                        _vm.handleSliderTouchEnd,
                                                                      dragstart:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          $event.stopPropagation()
                                                                        },
                                                                      drag: function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        $event.stopPropagation()
                                                                      },
                                                                      __r: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.formData,
                                                                          "hours_available_min",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex justify-between text-xs text-gray-500 mt-1 w-48",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "1 hr"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "60 hrs"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-end space-x-3" },
                            [
                              _c("UIButton", {
                                attrs: {
                                  variant: "outline",
                                  buttonText: "Cancel",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.closeModal },
                              }),
                              _c("UIButton", {
                                attrs: {
                                  variant: "black",
                                  buttonText: "Save Configuration",
                                  type: "submit",
                                  disabled: invalid || _vm.isLoading,
                                  loading: _vm.isLoading,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }